import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import parsePhoneNumber from "libphonenumber-js";
import { sendOtpToMobile } from "../../../redux/auth/actions";
import { useDispatch } from "react-redux";
import { Button, Form } from "react-bootstrap";
import { APP_CONST, AuthModals } from "../../../config/const";
import { useSelector } from "react-redux";
import { Toaster } from "../../../utils/toaster";
import PhoneInput from "react-phone-input-2";
import useAuthModalHook from "../../../hooks/useAuthModalHook";

const MobileNumberModal = ({ show }) => {
  const { updateActiveAuthModal } = useAuthModalHook();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const OTP = useSelector((state) => state?.app?.appDetails);
  const dispatch = useDispatch();

  const handleSubmit = () => {
    setIsSubmitting(true);
    const phoneNumber = parsePhoneNumber("+" + mobileNumber);
    let payload = {};
    if (phoneNumber) {
      payload.mobile = phoneNumber.nationalNumber;
      payload.country_code = phoneNumber.countryCallingCode;
    }

    dispatch(sendOtpToMobile(payload))
      .then((res) => {
        setIsSubmitting(false);
        if (res?.data?.error === false) {
          persistDetails(payload);

          if (OTP && OTP?.OTP === 0) {
            updateActiveAuthModal(AuthModals.VerifyNumber);
          } else {
            updateActiveAuthModal(AuthModals.Register);
          }
        } else {
          Toaster(APP_CONST.TOAST_TYPE.ERROR, res?.data?.message);
        }
      })
      .catch((err) => {
        Toaster(APP_CONST.TOAST_TYPE.ERROR, err?.response?.data?.message);
        setIsSubmitting(false);
      });
  };

  const persistDetails = (data) => {
    localStorage.setItem("mobile_details", JSON.stringify(data));
  };

  return (
    <Modal
      show={show}
      className={"steps-canvas login-register number"}
      onHide={() => {
        console.log("working");
      }}
      placement={"end"}
      centered
    >
      <Modal.Header
        closeButton
        onClick={() => updateActiveAuthModal(null)}
        closeVariant="black"
      ></Modal.Header>
      <Modal.Body>
        <div className="inner-wrapper">
          <h2 className="title">Join Now</h2>

          <Form>
            <Form.Group className="form-group" controlId="formBasicPassword">
              <PhoneInput
                country={"in"}
                inputProps={{
                  name: "phone",
                  required: true,
                }}
                // onlyCountries={["in", "bd"]}
                onlyCountries={["in"]}
                inputStyle={{
                  padding: "10px 10px",
                  paddingLeft: "50px",
                }}
                onChange={(phone) => {
                  setMobileNumber(phone);
                }}
              />
            </Form.Group>

            <Button
              variant="primary"
              className="loginbtn"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Loading.." : "Request OTP"}
            </Button>
          </Form>

          <div className="signin-signup">
            Already have an account?{" "}
            <a
              href="#"
              onClick={() => {
                updateActiveAuthModal(AuthModals.Login);
              }}
            >
              Sign In
            </a>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default MobileNumberModal;
